import { format } from "date-fns";
import React from "react";
import { MOBILE_BREAKPOINT } from "../config";
import { DisplayPeriod } from "../routes/brands/listings/CalendarView";
import styled from "../styles";
import { Chevron } from "./Chevron";
import { Flex } from "./Flex";
import { Text } from "./Text";

interface MonthNavigatorProps {
  displayedDate: Date;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
  navigationPeriod?: DisplayPeriod;
  todayLabel?: string;
}

export const MonthNavigator: React.FC<MonthNavigatorProps> = ({
  displayedDate,
  onPrevious,
  onNext,
  onToday,
  navigationPeriod = DisplayPeriod.Monthly,
  todayLabel = "Today",
}) => {
  return (
    <HeaderInnerFlex>
      <Flex align="center" justify="center">
        <DesktopOnly>
          <TodayButton onClick={onToday}>{todayLabel}</TodayButton>
        </DesktopOnly>
        <MonthNavWrap>
          <ChevronWrap onClick={onPrevious}>
            <Chevron colorPreset="text" width={9} direction="left" />
          </ChevronWrap>
          <ChevronWrap onClick={onNext}>
            <Chevron width={9} colorPreset="text" />
          </ChevronWrap>
          <Flex justify="center">
            <Text size="l" weight="bold" margin="0 s">
              {navigationPeriod === DisplayPeriod.Quarterly ? (
                <>
                  <span style={{ fontWeight: 400 }}>
                    Q{format(displayedDate, "Q")}
                  </span>{" "}
                  {format(displayedDate, "yyyy")}
                </>
              ) : (
                <>
                  {format(displayedDate, "MMMM")}{" "}
                  <span style={{ fontWeight: 400 }}>
                    {format(displayedDate, "yyyy")}
                  </span>
                </>
              )}
            </Text>
          </Flex>
        </MonthNavWrap>
      </Flex>
    </HeaderInnerFlex>
  );
};

const MonthNavWrap = styled(Flex)`
  align-items: center;
  user-select: none;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: 0px;
  }
`;

const ChevronWrap = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(p) => p.theme.spacing.m};
  color: ${(p) => p.theme.color.button.secondaryText};
  border-radius: ${(p) => p.theme.misc.borderRadiusSmall};

  &:hover {
    background: ${(p) => p.theme.color.card.callout};
  }
`;

const TodayButton = styled.div`
  border: 1.5px solid ${(p) => p.theme.color.button.secondaryBorder};
  border-radius: ${(p) => p.theme.misc.borderRadiusSmall};
  font-size: ${(p) => p.theme.typography.size.s};
  font-family: ${(p) => p.theme.typography.bodyFamily};
  font-weight: ${(p) => p.theme.typography.weight.bold};
  padding: 5px ${(p) => p.theme.spacing.l} 3px;
  margin-right: ${(p) => p.theme.spacing.s};
  box-sizing: border-box;
  margin-top: -2px;
  user-select: none;
  cursor: pointer;
  color: ${(p) => p.theme.color.typography.text};
  transition: background 300ms ease-out-in;

  :hover {
    background: ${(p) => p.theme.color.card.callout};
  }
`;

const HeaderInnerFlex = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`;

const DesktopOnly = styled.div`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: none;
  }
`;
